import pluralize from 'pluralize';
import { memo } from 'react';

import { FileStatusIconCompleted, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { EllipsisInMiddle } from '~/components/EllipsisInMiddle';
import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type AssetRestorationTask, type GetCompletedMetadata } from '~/store/tasks/types';

export type RestoreAssetTaskCompletedPanelItemProps = {
  metadata: GetCompletedMetadata<AssetRestorationTask>;
  onClear: () => void;
};

export const RestoreAssetTaskCompletedPanelItem = memo(
  ({ metadata: { assets }, onClear }: RestoreAssetTaskCompletedPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const recoveredTitle = `${pluralize('asset', assets.length, true)} recovered`;

    return (
      <PaneItemTW
        truncate={false}
        avatar={<FileStatusIconCompleted size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={<FileStatusTitle>{ui2026 ? recoveredTitle : 'Recovered successfully'}</FileStatusTitle>}
        subtitle={
          <FileStatusSubtitle className="flex text-nowrap">
            {assets.length === 1 ? (
              <>
                <span className="flex-none pr-1">Recovered asset: </span>
                <EllipsisInMiddle className="font-bold" text={assets[0].title || ''} />
              </>
            ) : (
              <span className="truncate">Recovered {assets.length} assets</span>
            )}
          </FileStatusSubtitle>
        }
        buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
      />
    );
  },
);

RestoreAssetTaskCompletedPanelItem.displayName = 'RestoreAssetTaskCompletedPanelItem';
